(function(){
var oldStyle = document.getElementById('kmc-card-row-alignment-style');
if (oldStyle) oldStyle.remove();
if (!document.getElementById('kmc-card-clean-selectors-style')) {
var style = document.createElement('style');
style.id = 'kmc-card-clean-selectors-style';
style.textContent = [
'.kmc-card-variant-pills.kmc-card-variant-pills--dropdown{display:block;margin:.5rem 0 .65rem}',
'.kmc-card-variant-pills--dropdown .kmc-card-variant-button{display:none}',
'.kmc-card-variant-select-wrap{position:relative;width:100%}',
'.kmc-card-variant-dropdown-select{appearance:none;width:100%;min-height:4.4rem;border:.1rem solid rgba(40,114,79,.35);border-radius:999px;background:#fff;color:#28724f;font:inherit;font-size:1.12rem;font-weight:800;line-height:1.2;padding:.72rem 3.2rem .72rem 1.3rem;cursor:pointer;text-align:center}',
'.kmc-card-variant-select-wrap:after{content:"⌄";position:absolute;top:50%;right:1.25rem;transform:translateY(-56%);color:#28724f;font-size:1.4rem;pointer-events:none}',
'.kmc-card-dynamic-price{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:center;gap:.2rem .5rem;margin:.25rem 0 .15rem;color:#1f1f1f}',
'.kmc-card-dynamic-price__compare{opacity:.5;text-decoration:line-through;font-size:1.15rem;font-weight:750}',
'.kmc-card-dynamic-price__current{font-size:1.35rem;font-weight:900;color:#1f1f1f}',
'.kmc-card-dynamic-price__unit{flex-basis:100%;font-size:1.02rem;font-weight:800;color:#6f8c7f;line-height:1.1}',
'.kmc-card-purchase-tab .kmc-card-dynamic-price{margin:0}.kmc-card-purchase-tab .kmc-card-dynamic-price__current{font-size:1rem}.kmc-card-purchase-tab .kmc-card-dynamic-price__compare{font-size:.95rem}.kmc-card-purchase-tab .kmc-card-dynamic-price__unit{font-size:.88rem}',
'.kmc-card-purchase-tab:has(input:checked) .kmc-card-dynamic-price__current{color:#28724f}'
].join('\n');
document.head.appendChild(style);
}
})();
function kmcParseMoney(text) {
var numeric = String(text || '').replace(/[\u00a0\u202f\s]/g, '').replace(/[^\d.,+\-]/g, '');
if (!numeric) return null;
var sign = numeric.indexOf('-') !== -1 ? -1 : 1;
numeric = numeric.replace(/[+\-]/g, '');
var lastDot = numeric.lastIndexOf('.');
var lastComma = numeric.lastIndexOf(',');
var decimalIndex = -1;
if (lastDot !== -1 && lastComma !== -1) decimalIndex = Math.max(lastDot, lastComma);
else {
var separatorIndex = Math.max(lastDot, lastComma);
if (separatorIndex !== -1) {
var digitsAfter = numeric.length - separatorIndex - 1;
if (digitsAfter > 0 && digitsAfter <= 2) decimalIndex = separatorIndex;
}
}
var normalized = decimalIndex !== -1 ? numeric.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' + numeric.slice(decimalIndex + 1).replace(/[.,]/g, '') : numeric.replace(/[.,]/g, '');
var amount = Number(normalized);
return Number.isFinite(amount) ? amount * sign : null;
}
function kmcEscapeHtml(value) {
return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
function kmcFormatMoney(amount, templateText) {
if (typeof amount !== 'number' || Number.isNaN(amount)) return '';
var template = String(templateText || '').trim();
var firstDigit = template.search(/\d/);
var lastDigit = -1;
for (var i = template.length - 1; i >= 0; i -= 1) { if (/\d/.test(template.charAt(i))) { lastDigit = i; break; } }
if (firstDigit === -1 || lastDigit === -1) return amount.toFixed(2);
var prefix = template.slice(0, firstDigit);
var suffix = template.slice(lastDigit + 1);
var numericTemplate = template.slice(firstDigit, lastDigit + 1);
var lastDot = numericTemplate.lastIndexOf('.');
var lastComma = numericTemplate.lastIndexOf(',');
var decimalSeparator = '.';
var decimalPlaces = 0;
if (lastDot !== -1 && lastComma !== -1) { decimalSeparator = lastDot > lastComma ? '.' : ','; decimalPlaces = numericTemplate.length - Math.max(lastDot, lastComma) - 1; }
else {
var separatorIndex = Math.max(lastDot, lastComma);
if (separatorIndex !== -1) {
var digitsAfter = numericTemplate.length - separatorIndex - 1;
if (digitsAfter > 0 && digitsAfter <= 2) { decimalSeparator = numericTemplate.charAt(separatorIndex); decimalPlaces = digitsAfter; }
}
}
var factor = Math.pow(10, decimalPlaces);
var roundedAmount = Math.round((amount + Number.EPSILON) * factor) / factor;
var fixed = roundedAmount.toFixed(decimalPlaces).split('.');
return prefix + fixed[0] + (decimalPlaces ? decimalSeparator + fixed[1] : '') + suffix;
}
function kmcGetPackCountFromText(text) {
text = String(text || '');
var match = text.match(/(\d+)\s*[x×]\s*\d+/i) || text.match(/(\d+)\s*(?:pack|gels|bars|serves|items)/i);
return match ? Number(match[1]) : null;
}
function kmcGetCardPackCount(form) {
var card = form ? form.closest('.card') : null;
var active = kmcGetActiveVariantTrigger(form);
var text = '';
if (active) text += ' ' + (active.textContent || '') + ' ' + (active.dataset.variantTitle || '');
if (card) text += ' ' + (card.querySelector('.card__heading')?.textContent || '');
return kmcGetPackCountFromText(text);
}
function kmcBuildDynamicPrice(currentText, compareText, packCount) {
var current = kmcParseMoney(currentText);
var compare = kmcParseMoney(compareText);
var safeCurrentText = kmcEscapeHtml(currentText || '');
var safeCompareText = kmcEscapeHtml(compareText || '');
var html = '<span class="kmc-card-dynamic-price">';
if (compare && current && compare > current) html += '<s class="kmc-card-dynamic-price__compare">' + safeCompareText + '</s>';
html += '<strong class="kmc-card-dynamic-price__current">' + safeCurrentText + '</strong>';
if (current && packCount) html += '<small class="kmc-card-dynamic-price__unit">' + kmcEscapeHtml(kmcFormatMoney(current / packCount, currentText)) + ' / item</small>';
html += '</span>';
return html;
}
function kmcUpdateCardMainPrice(form) {
if (!form) return;
var card = form.closest('.card');
if (!card) return;
var priceRoot = card.querySelector('.card-information .price__container');
if (!priceRoot) return;
if (!priceRoot.dataset.kmcOriginalHtml) priceRoot.dataset.kmcOriginalHtml = priceRoot.innerHTML;
var active = kmcGetActiveVariantTrigger(form);
var oneTimeRadio = form.querySelector('.kmc-card-purchase-onetime input');
var subscribeRadio = form.querySelector('.kmc-card-purchase-subscribe input');
var selectedPlan = kmcGetActiveFrequencySelect(form);
var packCount = kmcGetCardPackCount(form);
var variantPrice = active ? (active.dataset.variantPrice || '') : '';
var variantCompareAtPrice = active ? (active.dataset.variantCompareAtPrice || '') : '';
if (subscribeRadio && subscribeRadio.checked && subscribeRadio.dataset.sellingPlanId && selectedPlan && selectedPlan.options.length) {
var option = selectedPlan.options[selectedPlan.selectedIndex];
var subPrice = option ? (option.dataset.price || option.textContent || '') : '';
priceRoot.innerHTML = kmcBuildDynamicPrice(subPrice, variantPrice, packCount);
return;
}
if (active && variantPrice) priceRoot.innerHTML = kmcBuildDynamicPrice(variantPrice, variantCompareAtPrice, packCount);
else if (oneTimeRadio && oneTimeRadio.checked) priceRoot.innerHTML = priceRoot.dataset.kmcOriginalHtml;
}
function kmcUpdatePurchaseTabPrices(form) {
if (!form) return;
var active = kmcGetActiveVariantTrigger(form);
var packCount = kmcGetCardPackCount(form);
var variantPrice = active ? (active.dataset.variantPrice || '') : '';
var variantCompareAtPrice = active ? (active.dataset.variantCompareAtPrice || '') : '';
var oneTimePrice = form.querySelector('[data-kmc-one-time-price]');
var subPrice = form.querySelector('[data-kmc-subscription-price]');
var selectedPlan = kmcGetActiveFrequencySelect(form);
if (oneTimePrice && variantPrice) oneTimePrice.innerHTML = kmcBuildDynamicPrice(variantPrice, variantCompareAtPrice, packCount);
if (subPrice && selectedPlan && selectedPlan.options.length) {
var option = selectedPlan.options[selectedPlan.selectedIndex];
var planPrice = option ? (option.dataset.price || option.textContent || '') : '';
subPrice.innerHTML = kmcBuildDynamicPrice(planPrice, variantPrice, packCount);
}
}
function kmcUpdateSavingBadge(card) {
if (!card) return;
var badge = card.querySelector('[data-kmc-saving-badge]');
if (!badge) return;
var form = card.querySelector('.kmc-card-form');
var active = kmcGetActiveVariantTrigger(form);
var regularPrice = active ? kmcParseMoney(active.dataset.variantPrice || '') : null;
var compareAtPrice = active ? kmcParseMoney(active.dataset.variantCompareAtPrice || '') : null;
var referencePrice = compareAtPrice && regularPrice && compareAtPrice > regularPrice ? compareAtPrice : regularPrice;
var lowestEffectivePrice = regularPrice;
var subscriptionSelect = kmcGetActiveFrequencySelect(form);
if (subscriptionSelect && subscriptionSelect.options.length) {
Array.from(subscriptionSelect.options).forEach(function(option) {
var subscriptionPrice = kmcParseMoney(option.dataset.price || option.textContent || '');
if (subscriptionPrice && (!lowestEffectivePrice || subscriptionPrice < lowestEffectivePrice)) lowestEffectivePrice = subscriptionPrice;
});
}
var amount = referencePrice && lowestEffectivePrice && referencePrice > lowestEffectivePrice
? Math.round((referencePrice - lowestEffectivePrice) * 100 / referencePrice)
: 0;
if (amount > 0) { badge.textContent = 'Save ' + amount + '%'; badge.style.display = ''; }
else badge.style.display = 'none';
}
function kmcGetActiveVariantTrigger(form) {
if (!form) return null;
var dropdown = form.querySelector('[data-kmc-card-variant-dropdown]');
if (dropdown && dropdown.selectedOptions && dropdown.selectedOptions.length) return dropdown.selectedOptions[0];
return form.querySelector('.kmc-card-variant-button.is-active') || form.querySelector('[data-kmc-variant-id-input][data-variant-id]');
}
function kmcGetActiveFrequencySelect(form) {
var activeVariant = kmcGetActiveVariantTrigger(form);
var variantId = activeVariant ? activeVariant.dataset.variantId : '';
if (!variantId) return null;
return form.querySelector('[data-kmc-subscription-select][data-variant-id="' + variantId + '"]');
}
function kmcDecodePlanText(value) {
var field = document.createElement('textarea');
field.innerHTML = value || '';
return field.value;
}
function kmcApplySelectedPlan(form, updateBadge) {
if (!form) return;
var card = form.closest('.card');
var select = kmcGetActiveFrequencySelect(form);
var subscribeRadio = form.querySelector('.kmc-card-purchase-subscribe input');
var subTitle = form.querySelector('[data-kmc-subscription-title]');
var terms = form.querySelector('[data-kmc-subscription-terms]');
if (!subscribeRadio) return;
if (!select || select.disabled || select.options.length === 0) {
subscribeRadio.dataset.sellingPlanId = '';
if (terms) { terms.textContent = ''; terms.hidden = true; }
subscribeRadio.disabled = true;
if (subTitle) subTitle.textContent = subTitle.dataset.subscribeLabel || 'Subscribe';
if (updateBadge) kmcUpdateSavingBadge(card, '');
kmcUpdatePurchaseTabPrices(form);
kmcUpdateCardMainPrice(form);
return;
}
var selected = select.options[select.selectedIndex];
if (!selected) return;
subscribeRadio.dataset.sellingPlanId = selected.value || '';
if (terms) { terms.textContent = kmcDecodePlanText(selected.dataset.terms); terms.hidden = !terms.textContent.trim(); }
subscribeRadio.disabled = !selected.value;
if (subTitle) subTitle.textContent = selected.dataset.saving ? (subTitle.dataset.subscribeSavingLabel || 'Subscribe & save __percent__%').replace('__percent__', selected.dataset.saving) : (subTitle.dataset.subscribeLabel || 'Subscribe');
if (updateBadge) kmcUpdateSavingBadge(card, selected.dataset.saving || '');
kmcUpdatePurchaseTabPrices(form);
kmcUpdateCardMainPrice(form);
}
function kmcSetPurchaseMode(form) {
if (!form) return;
var wrapper = form.querySelector('.kmc-card-purchase-options');
var planInput = form.querySelector('[data-kmc-selling-plan-input]');
var subscribeRadio = form.querySelector('.kmc-card-purchase-subscribe input');
var isSubscribe = subscribeRadio && subscribeRadio.checked && subscribeRadio.dataset.sellingPlanId;
if (wrapper) wrapper.classList.toggle('is-subscription-active', !!isSubscribe);
if (planInput) {
if (isSubscribe) { planInput.disabled = false; planInput.value = subscribeRadio.dataset.sellingPlanId; }
else { planInput.value = ''; planInput.disabled = true; }
}
kmcUpdateCardMainPrice(form);
}
function kmcApplyVariantChoice(form, source) {
if (!form || !source || source.disabled) return;
form.closest('product-form')?.resetCartError?.();
var card = form.closest('.card');
var variantId = source.dataset.variantId;
var variantInput = form.querySelector('[data-kmc-variant-id-input]');
var dropdown = form.querySelector('[data-kmc-card-variant-dropdown]');
var subscribeOption = form.querySelector('.kmc-card-purchase-subscribe');
var subscribeRadio = subscribeOption ? subscribeOption.querySelector('input') : null;
var oneTimeRadio = form.querySelector('.kmc-card-purchase-onetime input');
var hasPlan = !!source.dataset.sellingPlanId;
if (variantInput && variantId) variantInput.value = variantId;
if (dropdown && variantId && dropdown.value !== variantId) dropdown.value = variantId;
form.querySelectorAll('.kmc-card-variant-button').forEach(function(item) {
var active = item.dataset.variantId == variantId;
item.classList.toggle('is-active', active);
item.setAttribute('aria-pressed', active ? 'true' : 'false');
});
form.querySelectorAll('[data-kmc-subscription-select]').forEach(function(select) {
var isCurrent = select.dataset.variantId == variantId;
select.classList.toggle('hidden', !isCurrent);
select.disabled = !isCurrent;
});
if (subscribeOption) subscribeOption.style.display = hasPlan ? '' : 'none';
if (!hasPlan && subscribeRadio && subscribeRadio.checked && oneTimeRadio) oneTimeRadio.checked = true;
kmcUpdateSavingBadge(card, source.dataset.saving || source.dataset.subscriptionSaving);
kmcApplySelectedPlan(form, false);
kmcSetPurchaseMode(form);
kmcUpdatePurchaseTabPrices(form);
kmcUpdateCardMainPrice(form);
}
function kmcCreateVariantDropdown(form) {
var group = form.querySelector('.kmc-card-variant-pills');
if (!group || group.dataset.kmcVariantDropdownReady === 'true') return;
var buttons = Array.from(group.querySelectorAll('.kmc-card-variant-button'));
if (buttons.length <= 3) return;
var select = document.createElement('select');
select.className = 'kmc-card-variant-dropdown-select';
select.setAttribute('data-kmc-card-variant-dropdown', '');
select.setAttribute('aria-label', group.getAttribute('aria-label') || 'Choose option');
buttons.forEach(function(button) {
var option = document.createElement('option');
option.value = button.dataset.variantId || '';
option.textContent = button.textContent.trim();
option.label = button.getAttribute('aria-label') || option.textContent;
option.disabled = button.disabled;
Object.keys(button.dataset).forEach(function(key) { option.dataset[key] = button.dataset[key]; });
if (button.classList.contains('is-active')) option.selected = true;
select.appendChild(option);
});
var wrap = document.createElement('div');
wrap.className = 'kmc-card-variant-select-wrap';
wrap.appendChild(select);
group.insertBefore(wrap, group.firstChild);
group.classList.add('kmc-card-variant-pills--dropdown');
group.dataset.kmcVariantDropdownReady = 'true';
}
function kmcInitialiseCardForm(form) {
kmcCreateVariantDropdown(form);
var activeVariant = kmcGetActiveVariantTrigger(form);
if (activeVariant) kmcApplyVariantChoice(form, activeVariant);
kmcApplySelectedPlan(form, false);
kmcSetPurchaseMode(form);
kmcUpdatePurchaseTabPrices(form);
kmcUpdateCardMainPrice(form);
}
if (!window.kmcCardDelegatesReady) {
window.kmcCardDelegatesReady = true;
document.addEventListener('DOMContentLoaded', function() { document.querySelectorAll('.kmc-card-form').forEach(kmcInitialiseCardForm); });
document.addEventListener('kmc:product-grid-updated', function(event) { event.target.querySelectorAll('.kmc-card-form').forEach(kmcInitialiseCardForm); });
document.addEventListener('shopify:section:load', function() { document.querySelectorAll('.kmc-card-form').forEach(kmcInitialiseCardForm); });
document.addEventListener('change', function(event) {
var variantDropdown = event.target.closest('[data-kmc-card-variant-dropdown]');
if (variantDropdown) {
var variantForm = variantDropdown.closest('form');
if (variantDropdown.selectedOptions.length) kmcApplyVariantChoice(variantForm, variantDropdown.selectedOptions[0]);
return;
}
var select = event.target.closest('[data-kmc-subscription-select]');
if (select) { var form = select.closest('form'); kmcApplySelectedPlan(form, true); kmcSetPurchaseMode(form); return; }
var purchaseRadio = event.target.closest('.kmc-card-purchase-tab input[type=radio]');
if (purchaseRadio) { var purchaseForm = purchaseRadio.closest('form'); kmcApplySelectedPlan(purchaseForm, purchaseRadio.value == 'subscribe'); kmcSetPurchaseMode(purchaseForm); }
});
document.addEventListener('click', function(event) {
var variantButton = event.target.closest('.kmc-card-variant-button');
if (!variantButton || variantButton.disabled) return;
var form = variantButton.closest('form');
kmcApplyVariantChoice(form, variantButton);
});
}
if (document.readyState !== 'loading') document.querySelectorAll('.kmc-card-form').forEach(kmcInitialiseCardForm);

